<template>
  <div
          v-if="testimonial"
  >
    <blockquote
            class="flex gap-x-3 flex-nowrap mb-2"
    >
      <IconQuote aria-hidden="true" class="size-8 text-brand shrink-0 grow-0"/>
      <MDC :value="testimonial.content" class="text-grey mb-2 text-sm italic" tag="div" unwrap=""/>
    </blockquote>
    <cite v-if="testimonial.author" class="w-full ps-11 text-sm not-italic">{{ testimonial.author }}</cite>
  </div>
</template>

<script lang="ts" setup>
interface Testimonial {
    item_key: string;
    content: string;
    author?: string;
    role?: string
}

const {itemKey} = defineProps<{
    itemKey: string;
}>();
const {data: testimonials} = useFetch<Testimonial[]>('/api/getCSV', {
    query: {
        file: 'project-testimonials.csv'
    },
    default: () => [],
    server: false,
});
const testimonial = computed<Testimonial | undefined>(() => testimonials.value?.find(t => t.item_key === itemKey));
</script>